import { render, staticRenderFns } from "./AddEditSchoolGrade.vue?vue&type=template&id=98592576&"
import script from "./AddEditSchoolGrade.vue?vue&type=script&lang=js&"
export * from "./AddEditSchoolGrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports